export default function PageTitle(props){
    return(
      <section className="section bg-white">
        <div className="container">
          {props.children}
        </div>
      </section>      
    );
}
